interface CRMWebhookData {
  name: string;
  email: string;
  phone: string;
  plan: string;
  billing?: string;
  status?: 'profile_created' | 'consent_completed' | 'payment_completed';
  timestamp?: string;
}

const CRM_WEBHOOK_URL = 'https://services.leadconnectorhq.com/hooks/wqBQikoAeBX1WKQA5aZp/webhook-trigger/0fb164ee-5593-46c4-8208-ef329edc0ca5';

export async function sendToCRM(data: CRMWebhookData): Promise<boolean> {
  try {
    const payload = {
      ...data,
      timestamp: new Date().toISOString(),
      source: 'lvlup-website'
    };

    const response = await fetch(CRM_WEBHOOK_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      console.error('CRM webhook failed:', response.status, response.statusText);
      return false;
    }

    console.log('CRM webhook sent successfully:', payload);
    return true;
  } catch (error) {
    console.error('Error sending to CRM:', error);
    return false;
  }
}
